module.exports = __webpack_public_path__ + "media/Video 145c.a934de24.mp4";